<template>
  <div class="flex justify-end items-center py-4">
    <font-awesome-icon :icon="['fas', 'bell']" class="text-xl mr-8" />
    <div class="w-[40px] h-[40px] text-lg bg-orange-100 rounded-full flex items-center justify-center mr-2">
      <font-awesome-icon :icon="['fas', 'child-reaching']" />
    </div>
    Influencer
  </div>
</template>
<script>
export default {
}
</script>